import { useLanguage } from "../../../contexts/LanguageContext";
import { CREDENTIAL_FIELDS } from "../providers";
import { Field, SecretInput, inputClass } from "./ui";

// The connection fields every provider has (keys, tokens, region, URL), in
// create and edit alike. All are required, as on the old screens.
export default function CredentialFields({ provider, values, setValue }) {
  const { t } = useLanguage();
  const fields = CREDENTIAL_FIELDS[provider.key] || [];

  return fields.map((field) => {
    const id = `integration-${field.name}`;
    const onChange = (e) => setValue(field.name, e.target.value);
    const docsLink =
      field.docs && provider.docsUrl ? (
        <a
          href={provider.docsUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="text-xs font-medium text-indigo-700 underline-offset-2 hover:underline"
        >
          {t("integrations.fields.howToGetKey")}
        </a>
      ) : null;

    let control;
    if (field.select) {
      control = (
        <select
          id={id}
          value={values[field.name]}
          onChange={onChange}
          required
          className={inputClass}
        >
          <option value="">{t("integrations.form.selectRegion")}</option>
          {field.select.map((option) => (
            <option key={option.value} value={option.value}>
              {t(option.labelKey)}
            </option>
          ))}
        </select>
      );
    } else if (field.secret) {
      control = (
        <SecretInput id={id} value={values[field.name]} onChange={onChange} required />
      );
    } else {
      control = (
        <input
          id={id}
          type="text"
          inputMode={field.inputMode}
          value={values[field.name]}
          onChange={onChange}
          placeholder={field.placeholder}
          required
          autoComplete="off"
          spellCheck={false}
          className={inputClass}
        />
      );
    }

    return (
      <Field
        key={field.name}
        label={t(field.labelKey)}
        htmlFor={id}
        hint={field.hintKey ? t(field.hintKey) : null}
        action={docsLink}
      >
        {control}
      </Field>
    );
  });
}
